import { useForm } from 'react-hook-form';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import { InregelingOpdracht } from '@/queries/mutaties/opdrachten';
import { useInregelen } from '@/queries/mutaties/useInregelen';

export type InregelingInputs = {
  datum: string;
};

const useInregelenDialog = (
  details: WerklijnContextMenuDetails,
  handleOpenChange: (open: boolean) => void,
  isUpdate: boolean,
) => {
  const { makenInregelen, verwijderenInregeling, wijzigenInregeling } = useInregelen();

  const { handleSubmit, reset, setValue } = useForm<InregelingInputs>({
    mode: 'onSubmit',
  });
  // reset all values
  const resetDialog = (closeButtonCLick: boolean) => {
    if (closeButtonCLick) {
      handleOpenChange(false);
    }
    reset();
  };

  function createOpdracht(target: InregelingInputs, isUpdate) {
    const inregelen: InregelingOpdracht = {
      eenheidnummer: details.eenheidnummer,
      datum: target.datum,
    };
    if (isUpdate) {
      inregelen.versie = details.inregelingVersie;
    }
    return inregelen;
  }

  const onSubmit = async (target: InregelingInputs) => {
    const opdracht = createOpdracht(target, isUpdate);
    await (async () => {
      const result = isUpdate ? await wijzigenInregeling(opdracht) : await makenInregelen(opdracht);
      if (result === 'SUCCES') resetDialog(true);
    })();
  };

  const verwijderInregelen = (details: WerklijnContextMenuDetails) => {
    (async () => {
      const result = await verwijderenInregeling({
        eenheidnummer: details.eenheidnummer,
        versie: details.inregelingVersie,
      });
      if (result === 'SUCCES') resetDialog(true);
    })();
  };

  return {
    onSubmit,
    resetDialog,
    handleSubmit,
    verwijderInregelen,
    setValue,
  };
};
export default useInregelenDialog;
